import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PromotionApprovalPage } from './promotion-approval.page';

const routes: Routes = [
  {
    path: '',
    component: PromotionApprovalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PromotionApprovalPageRoutingModule {}
